module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-widget"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "search-box",
    attrs: {
      "type": "text",
      "placeholder": "Search for Developers & Games"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "blur": _vm.hide,
      "focus": _vm.show,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.isHidden && (_vm.devMatches.length > 0 || _vm.gameMatches.length > 0 || _vm.searchMessage)) ? _c('div', {
    staticClass: "search-results"
  }, [(_vm.searchMessage) ? _c('span', [_vm._v(_vm._s(_vm.searchMessage))]) : _vm._e(), _vm._v(" "), (_vm.devMatches.length > 0) ? _c('h3', [_vm._v("Developers")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.devMatches), function(developer) {
    return _c('router-link', {
      staticClass: "match",
      attrs: {
        "to": ("/Developer/" + (developer.stringUrl))
      }
    }, [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": developer,
        "profile-type": "developer",
        "size": "small",
        "show-xp-info": false
      }
    })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(developer.alias))])])
  }), _vm._v(" "), (_vm.gameMatches.length > 0) ? _c('h3', [_vm._v("Games")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gameMatches), function(game) {
    return _c('router-link', {
      staticClass: "match",
      attrs: {
        "to": ("/Game/" + (game.stringUrl))
      }
    }, [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": game,
        "profile-type": "game",
        "size": "small",
        "show-xp-info": false
      }
    })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.alias))])])
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5179e8f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/SearchWidget.vue
// module id = 870
// module chunks = 2